import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import Carne from './carne';
import Contrato from './contrato';
// import Contratonovo from './contratonovo';
import Etiqueta from './etiqueta';

interface IUrlParams {
  id: string;
  tipo: string;
}

const CartaoSaudeImpressao: React.FC = () => {
  const { params } = useRouteMatch<IUrlParams>();
  const { tipo, id } = params;

  return (
    <div className="p-0 m-0 bg-white">
      {id && tipo === 'etiqueta' && <Etiqueta PlaCodigo={Number(id)} />}
      {id && tipo === 'contrato' && <Contrato ConCodigo={Number(id)} />}
      {id && tipo === 'carne' && <Carne PlaCodigo={Number(id)} />}
    </div>
  );
};

export default CartaoSaudeImpressao;
